import { raceAbort } from "@mirage-web/utils/abort-signals";

import { onlineManager } from "./online-manager";

const FETCH_NETWORK_ERROR_MESSAGES = new Set([
  "Failed to fetch",
  "Load failed",
  "Network request failed",
  "NetworkError when attempting to fetch resource.",
  "fetch failed",
  "network error",
]);

export function waitUntilOnline(signal: AbortSignal | null | undefined): Promise<void> | void {
  if (onlineManager.isOnline()) {
    return;
  }

  let unsubscribe = () => {};
  const waitForOnline = new Promise<void>((resolve) => {
    unsubscribe = onlineManager.subscribe((online) => {
      if (online) {
        resolve();
      }
    });

    if (onlineManager.isOnline()) {
      resolve();
    }
  });
  const abortableWait = signal ? raceAbort(signal, waitForOnline) : waitForOnline;

  return abortableWait.finally(unsubscribe);
}

export async function waitBeforeNetworkRetry(signal: AbortSignal | null | undefined) {
  if (globalThis.navigator?.onLine === false) {
    onlineManager.setOnline(false);
  }

  if (onlineManager.isOnline()) {
    return false;
  }

  await waitUntilOnline(signal);
  return true;
}

export function isFetchNetworkError(error: unknown) {
  return error instanceof TypeError && FETCH_NETWORK_ERROR_MESSAGES.has(error.message);
}
